export default {
  surveys: [],
  selectedSurvey: null,
  error: false,
  errorMessage: ''
}